import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { getUsers, UserModel } from '../../../services/user/UserService';

const pageSize = 5;

export interface UserData {
  data: UserModel[];
  page: number;
  pageSize: number;
  totalCount: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useUserList = (organizationId?: string) => {
  const [id, setOrganizationId] = useState(organizationId);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [users, setUsers] = useState<UserModel[]>([]);

  useEffect(() => {
    if (!id) {
      // TODO Set invalid properties
      return;
    }
    getUsersByPage(1);
  }, [id]);

  const getUsersByPage = async (page) => {
    try {
      if (id) {
        setIsLoading(true);
        const users = await getUsers(id, page, pageSize);
        const usersResult = users.data as unknown as UserData;
        setCurrentPage(page);
        setTotalCount(usersResult.totalCount);
        const usersTyped: UserModel[] = [];
        if (usersResult.data) {
          usersResult.data.forEach((user) => {
            usersTyped.push(user);
          });
        }

        setUsers(usersTyped);
      }
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { users, setOrganizationId, isLoading, getUsersByPage, pageSize, currentPage, totalCount };
};

export default useUserList;
